import styled from 'styled-components';

export const StyledThirdStep = styled.div`
  .ts-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &-box {
      border: 1px solid var(--color-light-gray) !important;
      border-radius: 6px;

      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > input {
          width: 40px !important;
        }
      }
    }
  }
`;

export const StyledThirdStepBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  > div {
    width: 342px;
    height: 65px;
    margin-bottom: 0;

    &.no-label {
      > span {
        color: transparent;
        user-select: none;

        > span {
          color: transparent;
          user-select: none;
        }
      }
    }
  }

  .checking-password {
    font-size: 14px;
    font-weight: 400;
    padding-left: 18px;
    position: relative;
    color: var(--color-warning);

    &.true {
      color: var(--color-success);

      &::before {
        background: var(--color-success);
      }
    }

    &::before {
      content: '';
      position: absolute;
      left: 0px;
      top: 48%;
      transform: translateY(-50%);
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: var(--color-warning);
    }
  }
`;
